// While a credential's paid verification is pending, and once it is
// verified, the server refuses changes to what the verifier reviews
// (credentials.service REVIEW_LOCKS). The description and whether it shows
// on the shared profile can still change.
const REVIEW_LOCK_NOTICES = {
  PENDING:
    "This credential is being verified, so only the additional info can change until the verifier decides.",
  VERIFIED:
    "This credential has been verified and verified details are view-only. Additional info can be edited directly.",
};

// The server refuses to delete these (credentials.service remove()).
const DELETE_LOCK_REASONS = {
  PENDING: "Can't be deleted while it is being verified",
  VERIFIED: "Verified credentials can't be deleted",
};

/** Why a credential's reviewed details can't be edited, or null if they can. */
export function reviewLockNotice(status) {
  return REVIEW_LOCK_NOTICES[status] ?? null;
}

/** Why a credential can't be deleted, or null if it can. */
export function deleteLockReason(status) {
  return DELETE_LOCK_REASONS[status] ?? null;
}
